module.exports = __webpack_public_path__ + "static/media/agenda.f0b6220e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/TransferCall/agenda.svg
// module id = 1841
// module chunks = 0